import { LitElement, html, css } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';

class BnSurface extends LitElement {
  static get properties() {
    return {
      noShadow: { type: Boolean, attribute: 'no-shadow' },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        --bn-surface-background-color: var(--surface, white);
        --bn-surface-border-color: transparent;
        --bn-surface-color: var(--on-surface, black);
        --bn-surface-header-background-color: var(--gray-20, #eee);
        --bn-surface-header-height: auto;
        display: block;
        background-color: var(--bn-surface-background-color);
        border: 2px solid var(--bn-surface-border-color);
        color: var(--on-surface, black);
        margin: var(--root-margin);
        padding: var(--root-margin);
        border-radius: 10px;
        box-shadow: rgb(0 0 0 / 10%) 0px 1px 3px;
      }
      :host([no-shadow]) {
        box-shadow: none;
      }
    `];
  }

  render() {
    return html`<slot></slot>`;
  }
}

window.customElements.define('bn-surface', BnSurface);
